var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.invoice.teamMemberInvoiceId
    ? _c("div", { staticClass: "action-dropdown" }, [
        _c(
          "div",
          [
            _vm.invoice.status === "Draft"
              ? _c(
                  "md-button",
                  {
                    staticClass: "btn-green md-just-icon md-round",
                    attrs: { title: "Approve Invoice" },
                    on: { click: _vm.approve },
                  },
                  [_c("md-icon", [_vm._v("thumb_up")])],
                  1
                )
              : _vm.invoice.status !== "OnHold"
              ? [
                  _vm.isSyncing
                    ? _c(
                        "div",
                        {
                          staticClass: "sync-loader md-button",
                          attrs: { title: _vm.invoice.retryTooltip },
                        },
                        [_c("straight-line-loader")],
                        1
                      )
                    : _c(
                        "md-button",
                        {
                          staticClass: "md-just-icon md-round",
                          class: _vm.buttonColor,
                          attrs: { title: _vm.buttonTitle },
                          on: { click: _vm.sync },
                        },
                        [_c("md-icon", [_vm._v(_vm._s(_vm.buttonIcon))])],
                        1
                      ),
                ]
              : _c(
                  "md-button",
                  {
                    staticClass: "btn-orange md-just-icon md-round",
                    attrs: { title: "Invoice On Hold" },
                  },
                  [
                    _c("md-icon", [_vm._v("pause_circle")]),
                    _c("md-tooltip", { attrs: { "md-direction": "left" } }, [
                      _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.onHoldToolTip) },
                      }),
                    ]),
                  ],
                  1
                ),
            _c(
              "md-button",
              {
                staticClass: "btn-blue md-just-icon md-round",
                attrs: { title: "Preview PDF" },
                on: { click: _vm.previewPdf },
              },
              [_c("md-icon", [_vm._v("preview")])],
              1
            ),
            _c(
              "md-button",
              {
                staticClass: "btn-blue md-just-icon md-round",
                attrs: { title: "Download Excel" },
                on: { click: _vm.generateExcel },
              },
              [_c("md-icon", [_vm._v("download")])],
              1
            ),
            _vm.invoice.status === "Draft"
              ? [
                  _c(
                    "md-button",
                    {
                      staticClass: "md-just-icon md-round",
                      class: _vm.draftButtonColor,
                      attrs: { title: _vm.draftIconTitle },
                      on: { click: _vm.sendEmail },
                    },
                    [
                      _c("md-icon", [_vm._v(_vm._s(_vm.draftButtonIcon))]),
                      _vm.draftEmailToolTip
                        ? _c(
                            "md-tooltip",
                            { attrs: { "md-direction": "left" } },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.draftEmailToolTip) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              : [
                  !_vm.hasFeatureTeamMemberInvoiceDraftApproval
                    ? [
                        _c(
                          "md-button",
                          {
                            staticClass: "md-just-icon md-round",
                            class: _vm.invoice.lastEmailDateSent
                              ? "btn-green"
                              : "btn-blue",
                            attrs: { title: _vm.emailButtonTitle },
                            on: { click: _vm.sendEmail },
                          },
                          [
                            _c("md-icon", [
                              _vm._v(
                                _vm._s(
                                  _vm.invoice.lastEmailDateSent
                                    ? "mark_email_read"
                                    : "email"
                                )
                              ),
                            ]),
                            _vm.invoice.lastEmailDateSent
                              ? _c(
                                  "md-tooltip",
                                  { attrs: { "md-direction": "left" } },
                                  [
                                    _vm._v(
                                      "\n                        Sent on: " +
                                        _vm._s(
                                          _vm._f("dateTimeFormat")(
                                            _vm.invoice.lastEmailDateSent,
                                            _vm.DATE_TYPES.standardDate
                                          )
                                        ) +
                                        "\n                    "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                  _vm.hasFeatureTeamMemberInvoiceDraftApproval &&
                  _vm.invoice.teamMemberShouldApplyTax
                    ? [
                        _c(
                          "md-button",
                          {
                            staticClass: "md-just-icon md-round",
                            class: _vm.invoice.lastEmailDateSent
                              ? "btn-green"
                              : "btn-blue",
                            attrs: { title: _vm.emailButtonTitle },
                            on: { click: _vm.sendEmail },
                          },
                          [
                            _c("md-icon", [
                              _vm._v(
                                _vm._s(
                                  _vm.invoice.lastEmailDateSent
                                    ? "mark_email_read"
                                    : "email"
                                )
                              ),
                            ]),
                            _vm.invoice.lastEmailDateSent
                              ? _c(
                                  "md-tooltip",
                                  { attrs: { "md-direction": "left" } },
                                  [
                                    _vm._v(
                                      "\n                        Sent on: " +
                                        _vm._s(
                                          _vm._f("dateTimeFormat")(
                                            _vm.invoice.lastEmailDateSent,
                                            _vm.DATE_TYPES.standardDate
                                          )
                                        ) +
                                        "\n                    "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ],
            _c(
              "md-button",
              {
                staticClass: "btn-red md-just-icon md-round",
                attrs: { title: "Delete Invoice" },
                on: { click: _vm.remove },
              },
              [_c("md-icon", [_vm._v("delete")])],
              1
            ),
          ],
          2
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }